module.exports = __webpack_public_path__ + "img/phone-documents.cbe8ae7c.webp";